function App() {
  // Access environment variables using process.env
  // For example, to read REACT_APP_API_URL:
  const version = process.env.VERSION;

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Hello World</h1>
      <p>This is the demo React app v.{version} deployed to GCP Storage Bucket 🚀 </p>
    </div>
  );
}

export default App;